export type TranscriptionChannel = "phone" | "video"

// A message is only ever sent when a transcription STARTS; channel is the one taking the
// microphone. Because a single microphone is shared, receiving any message means another
// transcription just started, so every other context must stop — there is no "stop" message.
export type CallStatusMessage = { channel: TranscriptionChannel }

const CALL_STATUS_CHANNEL_NAME = "sofia:call-status"

// One channel per browser context (tab/window). A BroadcastChannel never delivers a message
// to the object that posted it, so posting here only ever reaches OTHER tabs/windows — never
// a listener in this same tab. Cross-context is the only coordination transcription needs:
// phone runs in the agent tab, video in a popup.
const callStatusChannel = new BroadcastChannel(CALL_STATUS_CHANNEL_NAME)

export function broadcastCallStatus(message: CallStatusMessage): void {
  callStatusChannel.postMessage(message)
}

export function subscribeToCallStatus(listener: (event: MessageEvent<CallStatusMessage>) => void): () => void {
  callStatusChannel.addEventListener("message", listener)
  return () => callStatusChannel.removeEventListener("message", listener)
}
